import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import layout from "../layout";
import { useState, useEffect } from "react";
import Home from "./Home";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import axios from "../axios";
import { toast } from "react-toastify";
import DropDownWithFetchApi from "./DropDownWithFecthApi";
import MultipleDropdownWithFetchApi from "./MultipleDropdownWithFetchApi";
import DropDownWithExternalFetchApi from "./DropDownWithExternalFetchApi";
import SelectDropdown from "./SelectDropDown";
import FileUploader from "./FileUploader";


const Main = ({ resultant_layout, isLoggedIn }) => {
  //set headers
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("@token"),
  };
  // get all columns
  const resource = resultant_layout.resource;
  const important_columns = resultant_layout.important_columns;
  const viewable_columns = resultant_layout.viewable_columns;
  const createable_columns = resultant_layout.createable_columns;
  const editable_columns = resultant_layout.editable_columns;
  const column_type = resultant_layout.column_type;
  //create empty object of resource
  let obj = {};
  createable_columns.map((col) => {
    obj[col] = column_type[col].default ? column_type[col].default : null;
  });

  // set state for display message
  const [message, setMessage] = useState("");
  // console.log("message: ", message);

  // set loading state
  const [loading, setLoading] = useState(false);

  //Get all api data
  const [column, setColumn] = useState([]);
  const [records, setRecords] = useState([]);
  const getAllApiData = async () => {
    try {
      const res = await axios.get(resource, { headers });
      setColumn(important_columns);
      setRecords(res.data);
      setMessage(`Success. All ${resource} data fetched`);
      // toast.success(`Success. All ${resource} data fetched`);
    } catch (error) {
      setMessage(error);
      toast.error(error);
    }
  };

  //Get individual api data
  const [record, setRecord] = useState({});
  const [recordId, setRecordId] = useState();
  const getApiData = async () => {
    if (recordId === undefined || recordId === null || recordId === "") return;
    try {
      const res = await axios.get(resource + "/" + recordId, { headers });

      // Loop through the columns and apply JSON.stringify if type is "json_type"
      for (const key in column_type) {
        if (column_type[key].type === "json_type" && res.data[key]) {
          // Apply JSON.stringify for columns of type json_type
          res.data[key] = JSON.stringify(res.data[key] || []);
        }
      }

      setRecord(res.data);
      setForm(res.data);
      setRecordId(res.data.id);
      setMessage(`Success. Data Fetched for ${resource} ${recordId}`);
      // toast.success(`Success. Data Fetched for ${resource} ${recordId}`);
    } catch (error) {
      setMessage(error);
      toast.error(error);
    }
  };

  //Create api data
  // console.log("useState", useState(obj));
  const [form, setForm] = useState(obj);
  // console.log("init obj", JSON.parse(JSON.stringify(obj)));
  // console.log("form", form);
  const handleInput = (e, name) => {
    // console.log("form before", form);
    let value = e.target.value;
    const colType = column_type[name].type;

    switch (colType) {
      case "dropdownWithFetchApi":
        // console.log("texto", e);
        // console.log("value.id: ", value);
        setForm({ ...form, [name]: value });
        break;
      case "dropdownWithFetchApiAndCustomImplementation":
        // console.log("input-values ", e.target);
        // const selectedOption = e.target.selectedOptions[0].getAttribute("value");
        // column_type[name].customImplementation(selectedOption);
        // setForm({ ...form, [name]: value });
        if(resource == "Category") {
          const { name, value } = e.target;
          column_type[name].customImplementation(value);
          const fieldName = name === "category_name" ? "parent_id" : name;
          setForm((prevForm) => {
            const updatedForm = { ...prevForm, [fieldName]: value };
            // Remove category_name if present
            if (name === "category_name") {
              delete updatedForm.category_name;
            }
            return updatedForm;
          });
        }
        else if(resource == "Tags") {
          const { name, value } = e.target;
          column_type[name].customImplementation(value);
          const fieldName = name === "category_name" ? "root_category_id" : name;
          setForm((prevForm) => {
            const updatedForm = { ...prevForm, [fieldName]: value };
            // Remove category_name if present
            if (name === "category_name") {
              delete updatedForm.category_name;
            }
            return updatedForm;
          });
        }
        else if(resource == "Raga") {
          const { name, value } = e.target;
          column_type[name].customImplementation(value);
          const fieldName = name === "category_name" ? "category_id" : name;
          setForm((prevForm) => {
            const updatedForm = { ...prevForm, [fieldName]: value };
            // Remove category_name if present
            if (name === "category_name") {
              delete updatedForm.category_name;
            }
            return updatedForm;
          });

        }
        else {
          const { name, value } = e.target;
          column_type[name].customImplementation(value);
          setForm((prevForm) => ({ ...prevForm, [name]: value }));
        }
        break;
      case "dropdownWithExternalFetchApi":
        // console.log("input-values ", e.target);
        const iso2 = e.target.selectedOptions[0].getAttribute("data-iso2");
        // console.log("iso2: ", iso2);
        column_type[name].customImplementation(iso2);
        // console.log("window.ciso: ", window.ciso);
        setForm({ ...form, [name]: value });
        break;
      case "multipleDropdownWithFetchApi":
        // console.log("input-values ", e);
        const selectedOptions = form[name] || []; // Existing selections
        selectedOptions.push(e);
        setForm({ ...form, [name]: selectedOptions });
        break;
      case "dropdownWithFetchApiAndCustomImplementationArray":
        // const selectedOptions2 = Array.from(e.target.selectedOptions, option => option.value);
        // setForm({ ...form, [name]: selectedOptions2 });
        {
          const { name, value } = e.target; // value is expected to be an array
          setForm({ ...form, [name]: value });
        }
        break;
      case "multiline":
        setForm({ ...form, [name]: value });
        break;
      case "json_type":
        setForm({ ...form, [name]: value });
        break;
      case "array":
        
        setForm({ ...form, [name]: value });
      default:
        setForm({ ...form, [name]: value });
        break;
    }
    // const { name, value } = e.target;
    // setForm({ ...form, [name]: value });
    // console.log("form", JSON.stringify(form));
  };

  const postApiData = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      // Loop through column_type to check if the column type is 'json_type'
      for (const key in column_type) {
        if (column_type[key].type === "json_type" && form[key] && typeof form[key] === "string") {
          // Parse the string into JSON for json_type columns
          form[key] = JSON.parse(form[key]);
        }
      }

      // console.log("obj", JSON.stringify(obj));
      // console.log("form", JSON.stringify(form));
      let res = await axios.post(resource, form, { headers });
      // let resJson = await res.json();
      let resJson = await res.data;
      console.log("res status ::  " + resJson.status);
      if (res.status === 200 || res.status === 201) {
        // console.log(resJson);
        setMessage(`${resource} Created`);
        // toast.success(`${resource} Created`);
      } else {
        setMessage(`Failed to create ${resource}`);
        toast.error(`Failed to create ${resource}`);
      }
      //close modal and reload window
      handleCloseCreate();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "An unexpected error occurred";

      // console.log("Error --> " + errMsg);
      setMessage(errMsg);
      toast.error(errMsg);
    }
  };

  //Update api data
  const updateApiData = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      // Loop through column_type to check if the column type is 'json_type'
      for (const key in column_type) {
        if (column_type[key].type === "json_type" && form[key] && typeof form[key] === "string") {
          // Parse the string into JSON for json_type columns
          form[key] = JSON.parse(form[key]);
        }
      }

      // Force tag_ids into an array if it exists
      if (form.tag_ids) {
        if (typeof form.tag_ids === "string") {
          form.tag_ids = form.tag_ids
            .split(",")
            .map(id => id.trim())
            .filter(id => id !== "");
        }
      }
      let res = await axios.put(`${resource}/${recordId}`, form, { headers });
      // let resJson = await res.json();
      let resJson = await res.data;
      if (res.status === 200 || res.status === 201) {
        setMessage(resJson.message);
        // toast.success(resJson.message);
        setRecordId();
      } else {
        setMessage(resJson.message);
        toast.error(resJson.message);
      }
      //close modal and reload window
      handleCloseUpdate();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {

    const errMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "An unexpected error occurred";

      setMessage(errMsg);
      toast.error(errMsg);
    }
  };

  //Delete api data
  const deleteApiData = async () => {
    try {
      const res = await axios.delete(`${resource}/${recordId}`, { headers });
      getAllApiData();
      handleCloseDelete();
      setMessage(`Success. Data deleted for ${resource} ${recordId}`);
      // toast.success(`Success. Data deleted for ${resource} ${recordId}`);
    } catch (error) {
      setMessage(error);
      toast.error(error);
    }
  };

  //search query
  const [query, setQuery] = useState("");

  //filter query
  const [filters, setFilters] = useState({});
  const handleInputFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };
  const resetFilters = () => {
    setFilters({});
  };

  //state for modal - view
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => setShowView(false);
  const handleShowView = (value) => {
    setShowView(true);
    setRecordId(value);
    // toast.success(`Success. Data fetched for ${resource} ${value}`);
  };

  //state for modal - create
  const [showCreate, setShowCreate] = useState(false);
  const handleCloseCreate = () =>{ 
    setShowCreate(false);
  }
  const handleShowCreate = () => {
    setForm(obj);
    setShowCreate(true);
  };

  //state for modal - update
  const [showUpdate, setShowUpdate] = useState(false);
  const handleCloseUpdate = () => {
    setRecordId();
    setShowUpdate(false);
  }
  const handleShowUpdate = (id) => {
    setRecordId(id);
    // getApiData();
    setShowUpdate(true);
  };

  //state for modal - delete
  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);
  const handleShowDelete = (id) => {
    setRecordId(id);
    setShowDelete(true);
  };
  //pagination
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  //all useEffect
  useEffect(() => {
    setLoading(true);
    resetFilters();
    getAllApiData().finally(() => {
      setLoading(false);
    });
  }, [resultant_layout]);

  useEffect(() => {
    if (recordId === undefined || recordId === null || recordId === "") return;
    setLoading(true);
    getApiData().finally(() => {
      setLoading(false);
    });
  }, [recordId]);

  function refreshPage() {
    window.location.reload();
  }
  // For creator_email
  const emailOptions = Array.from(
    new Set(records.map((r) => r.creator_email).filter(Boolean))
  ).map((email) => ({ value: email, label: email }));

  // For category_name (it working for notes table, tag table and category table because i am passing category_name column to all these table query to create drop down option)
  const categoryOptions = Array.from(
    new Set(records.map((r) => r.category_name).filter(Boolean))
  ).map((cat) => ({ value: cat, label: cat }));

  // For tag_name
  const tagOptions = Array.from(
    new Set(records.map((r) => r.tag_name).filter(Boolean))
  ).map((tag) => ({ value: tag, label: tag }));

  if (!isLoggedIn) return <p>Please Login to continue</p>;
  return (
    <main className="legacy-page">
      {/* <div style={{ textDecoration: "none", color: "inherit" }}>
        <button style={{ color: "red", fontWeight: "bold" }} onClick={ refreshPage }>
        <i className="bi bi-arrow-clockwise me-2 fs-5"></i>
          Refresh!
        </button>
      </div> */}
      <div className="legacy-header">
        <div>
          <p className="legacy-eyebrow">Data workspace</p>
          <h1>{resource}</h1>
          <p className="legacy-subtitle">Manage {resource.toLowerCase()} records and operational metadata.</p>
        </div>
        <div className="legacy-header-actions">
          <div className="legacy-search"><i className="bi bi-search" /><input placeholder={`Search ${resource.toLowerCase()}…`} value={query} onChange={(event) => setQuery(event.target.value)} /></div>
          <button className="btn btn-primary" onClick={handleShowCreate}><i className="bi bi-plus-lg me-2" />Create {resource}</button>
        </div>
      </div>
      <div className="legacy-toolbar"><span><strong>{records.length}</strong> records</span><button className="btn btn-link btn-sm" onClick={resetFilters}><i className="bi bi-arrow-counterclockwise me-1" />Reset filters</button></div>
      <div>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="legacy-table-card table-responsive">
              <table className="table legacy-table align-middle">
                <thead>
                  <tr>
                    {column.map((c, i) => (
                      <th key={i} scope="col">
                        {c}
                        {(c === "creator_email" || c === "category_name" || c === "tag_name") && (
                          <SelectDropdown
                            columnName={c}
                            value={filters[c]}
                            onChange={handleInputFilter}
                            options={
                              c === "creator_email"
                                ? emailOptions
                                : c === "category_name"
                                ? categoryOptions
                                : tagOptions
                            }
                            maxWidth={230}
                          />
                        )}
                        {c !== "creator_email" && c !== "category_name" && c !== "tag_name" && (
                          <input
                            className="form-control form-control-sm legacy-column-filter"
                            name={c}
                            value={filters[c] || ""}
                            onChange={handleInputFilter}
                          />
                        )}
                      </th>
                    ))}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {records
                    .filter((record) => {
                      return Object.keys(filters).every((col) => {
                        const filterValue = filters[col]?.toLowerCase();
                        const columnValue = record[col]
                          ?.toString()
                          .toLowerCase();
                        return columnValue?.includes(filterValue);
                      });
                    })
                    .slice((pageNum - 1) * pageSize, pageSize * pageNum)
                    .filter((record) => {
                      return Object.keys(record).some(
                        (key) =>
                          record[key].toString().toLowerCase().search(query) !==
                          -1
                      );
                    })

                    .map((record, i) => {
                      return (
                        <tr key={i}>
                          {column.map((col) => {
                            const col_name = record[col];
                            return <td>{col_name}</td>;
                          })}
                          <td>
                            <button className="legacy-icon-button" title="View" aria-label="View" onClick={() => handleShowView(record.id)}><i className="bi bi-eye-fill" /></button>
                            <button className="legacy-icon-button" title="Edit" aria-label="Edit"
                              onClick={() => {
                                handleShowUpdate(record.id);
                              }}><i className="bi bi-pencil-square" /></button>
                            <button className="legacy-icon-button danger" title="Delete" aria-label="Delete" onClick={() => handleShowDelete(record.id)}><i className="bi bi-trash3" /></button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <div id="pagination" className="legacy-pagination">
                <div>
                  <p>Total results: {records.length}</p>
                </div>
                <div>
                  <select
                    value={pageSize}
                    onChange={(e) => setPageSize(e.target.value)}>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div>
                  <input
                    onChange={(e) => setPageNum(e.target.value)}
                    placeholder={pageNum}
                    style={{ width: "40px" }}></input>
                </div>
              </div>
            </div>




            {/* modal for view form */}
            <Modal show={showView} onHide={handleCloseView} id="view">
              <Modal.Header closeButton>
                <Modal.Title>
                  View {resultant_layout.resource} {recordId}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <Form>
                  {viewable_columns.map((col) => {
                    const colType = column_type[col]?.type;
                    const colValue = record[col];

                    return (
                      <Form.Group className="mb-3">
                        <Form.Label>{col}</Form.Label>
                        {/* <Form.Control placeholder={record[col]} disabled /> */}
                        {colType === "json_type" || colType === "multiline"? 
                        <Form.Control 
                          as="textarea" 
                          rows={3} 
                          disabled 
                          placeholder={colValue} 
                        />
                        :
                        <Form.Control 
                          disabled 
                          placeholder={colValue}  
                        />
                      }
                      </Form.Group>
                    );
                  })}
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseView}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleCloseView}>
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
            
            
            
            {/* modal for create form */}
            <Modal show={showCreate} onHide={handleCloseCreate} id="create">
              <Modal.Header closeButton>
                <Modal.Title>Create {resultant_layout.resource}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  {createable_columns.map((col) => {
                    const colType = column_type[col].type;
                    const colValue = form[col];
                    const colArray = column_type[col].value;
                    // console.log("colValue: ", colValue);
                    // console.log("col: ", col);
                    // console.log("apiUrl: ", column_type[col].apiURL);
                    return (
                      <Form.Group className="mb-3" key={col}>
                        <Form.Label>{col}</Form.Label>       
                        {colType === "dropdown" ? (
                          <Form.Select
                            name={col}
                            onChange={(e) => handleInput(e, col)}>
                              <option value="null">Select option below</option>
                            {colArray.map((col_value) => (
                              <option key={col_value} value={col_value}>
                                {col_value}
                              </option>
                            ))}
                          </Form.Select>
                        ) 
                        : colType === "dropdownWithFetchApi" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )
                        : colType === "dropdownWithFetchApiAndCustomImplementation" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )
                        : colType === "dropdownWithFetchApiAndCustomImplementationArray" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )  
                        : colType === "multipleDropdownWithFetchApi" ? (
                          <MultipleDropdownWithFetchApi
                            value={colValue||[]}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )
                        : colType === "dropdownWithExternalFetchApi" ? (
                          <DropDownWithExternalFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        ) 
                        : colType === "array" ? (
                          <Form.Control
                            type={colType}
                            name={col}
                            value={colValue}
                            step={column_type[col].step}
                            onChange={(e) => handleInput(e, col)}
                          />
                        )

                        : colType === "multiline" && (resultant_layout.resource == "Raga" || resultant_layout.resource == "Notes")? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />

                            {/* File Input */}
                            <FileUploader
                              uploadUrl="/extract-text"
                              allowedTypes={["image"]}
                              useCase = "extract-text"
                              onUploadSuccess={(response) => {
                                const existingValue = colValue || ""; // or wherever you store your current value
                                const updatedValue = existingValue
                                  ? `${existingValue}\n${response}` // separate with newline
                                  : response;
                                handleInput({ target: { value: updatedValue } }, col);
                              }}
                            />
                            
                          </div>
                        )
                        : colType === "json_type" && col == "audio_link"? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />
                            <FileUploader
                              uploadUrl="/upload-media"
                              allowedTypes={["audio"]}
                              userId={form.creator_id}
                              categoryId={form.category_id}
                              useCase = "upload-media"
                              onUploadSuccess={(fileUrl) => {
                                let existingUrls = [];
                                try {
                                  existingUrls = colValue ? JSON.parse(colValue) : [];
                                  if (!Array.isArray(existingUrls)) existingUrls = [];
                                } catch (e) {
                                  existingUrls = [];
                                }
                                const updatedUrls = [...existingUrls, fileUrl];
                                handleInput({ target: { value: JSON.stringify(updatedUrls) } }, col);
                              }}
                            />
                          </div>
                        )
                        : colType === "json_type" && col == "image_link"? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />
                            <FileUploader
                              uploadUrl="/upload-media"
                              allowedTypes={["image"]}
                              userId={form.creator_id}
                              categoryId={form.category_id}
                              useCase = "upload-media"
                              onUploadSuccess={(fileUrl) => {
                                let existingUrls = [];
                                try {
                                  existingUrls = colValue ? JSON.parse(colValue) : [];
                                  if (!Array.isArray(existingUrls)) existingUrls = [];
                                } catch (e) {
                                  existingUrls = [];
                                }
                                const updatedUrls = [...existingUrls, fileUrl];
                                handleInput({ target: { value: JSON.stringify(updatedUrls) } }, col);
                              }}
                            />
                          </div>
                        )
                        : colType === "multiline" || colType === "json_type"? (
                          <Form.Control
                            as="textarea"
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            rows={3}
                          />
                        )
                        :
                        (
                          <Form.Control
                            type={colType}
                            name={col}
                            value={colValue}
                            step={column_type[col].step}
                            onChange={(e) => handleInput(e, col)}
                          />
                        )}
                      </Form.Group>
                    );
                  })}
                  <Form.Group>
                    <Button
                      className="mb-3"
                      type="submit"
                      onClick={postApiData}>
                      Save
                    </Button>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseCreate}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            
            
            
            {/* Modal for update form */}
            <Modal show={showUpdate} onHide={handleCloseUpdate} id="Update">
              <Modal.Header closeButton>
                <Modal.Title>
                  Update {resultant_layout.resource} {recordId}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  {editable_columns.map((col) => {
                    const colType = column_type[col].type;
                    const colValue = form[col];
                    const colArray = column_type[col].value;
                    // console.log("colValue: ", colValue);
                    // console.log("apiUrl: ", column_type[col].apiURL);
             
                    return (
                      <Form.Group className="mb-3" key={col}>
                        <Form.Label>{col}</Form.Label>
                        {colType === "dropdown" ? (
                          <Form.Select
                            name={col}
                            onChange={(e) => handleInput(e, col)}>
                            {colArray.map((col_value) => (
                              <option key={col_value} value={col_value} selected={col_value === colValue}>
                                {col_value}
                              </option>
                            ))}
                          </Form.Select>
                        ) : colType === "dropdownWithFetchApi" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        ): colType === "dropdownWithFetchApiAndCustomImplementation" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )
                        : colType === "dropdownWithFetchApiAndCustomImplementationArray" ? (
                          <DropDownWithFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )  
                        : colType === "multipleDropdownWithFetchApi" ? (
                          <MultipleDropdownWithFetchApi
                            value={colValue||[]}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        )
                        : colType === "dropdownWithExternalFetchApi" ? (
                          <DropDownWithExternalFetchApi
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            apiUrl={column_type[col].apiURL}
                          />
                        ) : colType === "array" ? (
                          <Form.Control
                            type={colType}
                            name={col}
                            value={colValue}
                            step={column_type[col].step}
                            onChange={(e) => handleInput(e, col)}
                          />
                        )
                        : colType === "multiline" && (resultant_layout.resource == "Raga" || resultant_layout.resource == "Notes")? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />

                            {/* File Input */}
                            <FileUploader
                              uploadUrl="/extract-text"
                              allowedTypes={["image"]}
                              useCase = "extract-text"
                              onUploadSuccess={(response) => {
                                const existingValue = colValue || ""; // or wherever you store your current value
                                const updatedValue = existingValue
                                  ? `${existingValue}\n${response}` // separate with newline
                                  : response;
                                handleInput({ target: { value: updatedValue } }, col);
                              }}
                            />

                          </div>
                        )
                        : colType === "json_type" && col == "audio_link"? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />
                            <FileUploader
                              uploadUrl="/upload-media"
                              allowedTypes={["audio"]}
                              userId={form.creator_id}
                              categoryId={form.category_id}
                              useCase = "upload-media"
                              onUploadSuccess={(fileUrl) => {
                                console.log("Uploaded file:", fileUrl);
                                let existingUrls = [];
                                try {
                                  existingUrls = colValue ? JSON.parse(colValue) : [];
                                  if (!Array.isArray(existingUrls)) existingUrls = [];
                                } catch (e) {
                                  existingUrls = [];
                                }
                                const updatedUrls = [...existingUrls, fileUrl];
                                handleInput({ target: { value: JSON.stringify(updatedUrls) } }, col);
                              }}
                            />
                          </div>
                        )
                        : colType === "json_type" && col == "image_link"? (
                          <div>
                            {/* Textarea input */}
                            <Form.Control
                              as="textarea"
                              name={col}
                              value={colValue}
                              onChange={(e) => handleInput(e, col)}
                              rows={3}
                            />
                            <FileUploader
                              uploadUrl="/upload-media"
                              allowedTypes={["image"]}
                              userId={form.creator_id}
                              categoryId={form.category_id}
                              useCase = "upload-media"
                              onUploadSuccess={(fileUrl) => {
                                console.log("Uploaded file:", fileUrl);
                                let existingUrls = [];
                                try {
                                  existingUrls = colValue ? JSON.parse(colValue) : [];
                                  if (!Array.isArray(existingUrls)) existingUrls = [];
                                } catch (e) {
                                  existingUrls = [];
                                }
                                const updatedUrls = [...existingUrls, fileUrl];
                                handleInput({ target: { value: JSON.stringify(updatedUrls) } }, col);
                              }}
                            />
                          </div>
                        )
                        : colType === "multiline" || colType === "json_type"? (
                          <Form.Control
                            as="textarea"
                            name={col}
                            value={colValue}
                            onChange={(e) => handleInput(e, col)}
                            rows={3}
                          />
                        )
                         : (
                          <Form.Control
                            type={colType}
                            name={col}
                            value={colValue}
                            step={column_type[col].step}
                            onChange={(e) => handleInput(e, col)}
                          />
                        )}
                      </Form.Group>
                    );
                  })}
                  <Form.Group>
                    <Button
                      className="mb-3"
                      type="submit"
                      onClick={updateApiData}>
                      Save
                    </Button>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseUpdate}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

            
            
            {/* Modal for delete form */}
            <Modal show={showDelete} onHide={handleCloseDelete} id="Delete">
              <Modal.Header closeButton>
                <Modal.Title>
                  Delete {resultant_layout.resource} {recordId}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to delete {recordId}?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="mb-3"
                  variant="danger"
                  type="submit"
                  onClick={deleteApiData}>
                  Delete
                </Button>
                <Button
                  className="mb-3"
                  variant="secondary"
                  onClick={handleCloseDelete}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </div>
    </main>
  );
};

export default Main;
